import React from "react";
import ComingSoon from "./AIML/ComingSoon";
const AimlMain = () => {
  return (
    <div>   
        <ComingSoon />
    </div>
    );
};

export default AimlMain;